export default __webpack_public_path__ + "static/media/errSign.74c39b2b.svg";